// User-facing copy: talk. Moved from the web app (components/Composer.tsx, components/Discussion.tsx, pages/club/TalkTab.tsx) so the web and the app say the same thing.
// Strings that take values are functions. Generated keys; rename freely, they're just names.
/** components/Composer.tsx */
export const composer = {
    andSep: " and ",
    and: (join, x) => `${join} and ${x}`,
    open: "open",
    whoCanSeeThis: "Who can see this",
    everyoneSeesItWhatever: "Everyone sees it, whatever they've read.",
    sealedForAnyoneWho: "Sealed for anyone who isn't there yet.",
    landmarks: "Landmarks",
    through: (name) => `Through ${name}  `,
    p: (page) => ` · p. ${page}`,
    somewhereElse: "Somewhere else",
    pickThePercentIt: "Pick the percent it's about.",
    percent: "Percent",
    quoteFromTheBook: "Quote from the book",
    inTheBookS: "In the book's voice, at your spot.",
    backToAPlain: "Back to a plain message",
    questionForPeopleAhead: "Question for people ahead",
    sayWhereYouAre: (x) => `${x} Say where you are, like "just after chapter 4".`,
    pastAndWillAnswer: (listNames, x, posLabel) => `${listNames} ${x} past ${posLabel} and will answer without spoilers.`,
    is: "is",
    are: "are",
    nobodyIsPastYet: (posLabel) => `Nobody is past ${posLabel} yet. Your question will wait for them.`,
    spoilerAnswer: "Spoiler answer",
    sealedForUntil: (asker, posLabel) => `Sealed for ${asker} until ${posLabel}. `,
    keepItSpoilerFree: "Keep it spoiler-free",
    answeringWhoSAt: (asker, posLabel) => `Answering ${asker}, who's at ${posLabel}.`,
    notSureWhatThey: "Not sure what they've reached? ",
    markItAsA: "Mark it as a spoiler",
    andItOpensWhen: " and it opens when they get there.",
    replyingTo: "Replying to ",
    stopReplying: "Stop replying",
    moreWaysToPost: "More ways to post",
    shareAQuote: "Share a quote",
    aPassageFromThe: "A passage from the book, shown with your spot.",
    askPeopleAhead: "Ask people ahead",
    aQuestionForReaders: "A question for readers past you. Answers stay spoiler-free.",
    pasteThePassage: "Paste the passage",
    yourQuestion: "Your question",
    answerNoSpoilers: "Answer, no spoilers",
    postedAt: (position) => `Posted at ${position}%`,
    visibility: (chipText) => `Visibility: ${chipText}`,
    reply: "Reply",
    send: "Send",
    spoilerFree: "Spoiler-free",
};
/** components/Discussion.tsx */
export const discussion = {
    finishLine: "Finish line",
    forEveryoneWhoHas: (x) => ` · for everyone who has reached the end${x}`,
    reply: "reply",
    replies: "replies",
    spoilerAnswer: "Spoiler answer",
    opensAt: (name, posLabel) => ` · ${name} · opens at ${posLabel}`,
    until: (x, posLabel) => `${x} until ${posLabel}`,
    sealed: "Sealed",
    spoiler: "Spoiler",
    readItAnyway: "Read it anyway",
    save: "Save",
    cancel: "Cancel",
    new: "New",
    you: "You",
    discussedAtTheMeeting: "Discussed at the meeting",
    forTheMeeting: "For the meeting",
    flaggedForTheMeeting: "Flagged for the meeting",
    left: "left",
    openedEarly: " · opened early",
    spoiler2: (posLabel) => ` spoiler · ${posLabel}`,
    justOpened: "Just opened",
    edited: " · edited",
    commentRemoved: "Comment removed",
    answered: "Answered",
    questionForPeopleAhead: "Question for people ahead",
    noAnswersYet: "No answers yet",
    answer: "answer",
    answers: "answers",
    youReAheadAnswer: "You're ahead · answer",
    thatAnswersIt: "That answers it",
    reply2: "Reply",
    deleteThis: (x) => `Delete this${x}?`,
    repliesStay: (replyCount) => ` (${replyCount} replies stay)`,
    delete: "Delete",
    keep: "Keep",
    more: "More",
    openTheQuestion: "Open the question",
    replyInThread: "Reply in thread",
    notAnsweredYet: "Not answered yet",
    notForTheMeeting: "Not for the meeting",
    replyTo: (x) => `Reply to ${x}`,
    yourself: "yourself",
    edit: "Edit",
};
/** pages/club/TalkTab.tsx */
export const tab = {
    yourPrivateNotesOn: "Your private notes on this book",
    yourNotes: "Your notes",
    shelf: "Shelf",
    youReAt: "you're at ",
    gatingOff: "gating off",
    nobodyHasSaidAnything: "Nobody has said anything yet",
    sayWhereYouAre: "Say where you are, or set the chip to spoiler-free for the small talk.",
    newSinceYourLast: "New since your last visit",
    whereIAm: "Where I am",
    messageTheClub: "Message the club",
    leaveANoteForward: "Leave a note forward",
    itWaitsAtA: "It waits at a page for whoever gets there after you.",
    makeAPrediction: "Make a prediction",
    sealedUntilEachReader: "Sealed until each reader finishes.",
    thread: "Thread",
    yourQuestion: "Your question",
    question: "Question",
    closeThread: "Close thread",
    firstReactions: "First reactions",
    finishTheBookTo: "Finish the book to see them.",
    stoppedAt: (percent) => ` · stopped at ${percent}%`,
    arrivedWithoutAWord: "arrived without a word",
    nobodyHasAnsweredYet: "Nobody has answered yet.",
    noRepliesYet: "No replies yet.",
    thisThread: "This thread",
    reply: "Reply",
    replyInThread: "Reply in thread",
    theDiscussionOpensWith: "The discussion opens with the first book",
    pickTheFirstBook: "Pick the first book",
    goToTheShelf: "Go to the Shelf",
    sayHiOnThe: "Say hi on the noticeboard",
    messagesAreTiedTo: "Messages are tied to where you are in the book. Anything past your spot stays sealed until you get there.",
};
//# sourceMappingURL=talk.js.map